import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addTeamsType, deleteTeamsType, getAllTeamsType, updateTeamsType } from '../../redux/rtk/features/masters/teamsTypeSlice';
import PageTitle from '../page-header/PageHeader';

const TeamsTypeMaster = () => {
  const { Title } = Typography;
  const [editingTeamsType, setEditingTeamsType] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.teamsType);

  useEffect(() => {
    dispatch(getAllTeamsType());
  }, [dispatch]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingTeamsType) {
        // Update existing teamsType
        const result = await dispatch(
          updateTeamsType({ id: editingTeamsType.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllTeamsType());
        } else {
          message.error('Error updating teamsType!');
        }
      } else {
        // Add new teamsType
        const result = await dispatch(addTeamsType(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllTeamsType());
        } else {
          message.error('Error adding teamsType!');
        }
      }
      setEditingTeamsType(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      // message.error('Failed to add or update teamsType!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteTeamsType(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllTeamsType()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Team Type',
      dataIndex: 'teamsType',
      key: 'teamsType',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {setEditingTeamsType(record); form.setFieldsValue(record);}}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this team type?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
        <Card title={editingTeamsType ? 'Edit Team Type' : 'Add Team Type'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="team-type-form"
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
          <Form.Item
            name="teamsType"
            label="Team Type"
            rules={[{ required: true, message: 'Please enter a team type!' }]}
          >
            <Input placeholder="Enter team Type " />
          </Form.Item>

          <Button type="primary" block htmlType="submit">
                {editingTeamsType ? 'Update Team Type' : 'Add Team Type'}
              </Button>
            </Form>
        </Card>
        </Col>
        <Col span={16}>
          <Card title="Team Type List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
        </Row>
    </div>
  );
};

export default TeamsTypeMaster;
